import React from "react";
import { Button, InfiniteScroll, Progress } from "nq-component";
import LeaveTablePresenter from "./LeaveTablePresenter";
import BaseListPage from "../../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import CardView from "../../../../../components/common/CardView";
import Search from "../../../../../components/Search";
import Table from "../../../../../components/Table";
import withRouter from "../../../../../withRouter";
import SearchSelect from "../../../../../components/searchSelect/SearchSelect";
import DateRangePicker from "../../../../../components/common/DateRangePicker";
import InputFactory from "../../../../../components/InputFactory";

class LeaveTablePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new LeaveTablePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      type: [],
      // status: [],
      filteredLeaves: "",
      count: 0,
      limit: 10,
      current: 1,
      where: {},
      whereReady: false,
    };
  }
  async componentDidMount() {
    this.presenter.componentDidMount();
    const type = await findObjectUseCase().execute("leave_type", {
      keys: ["name"],
    });
    // const status = await findObjectUseCase().execute("leave_request");
    this.setState({ type });
  }

  async onChangeForm(field, value) {
    if (field === "leavType") {
      this.presenter.onChangeFilter("String", value, "selectedType");
    } else if (field === "filteredstatus") {
      this.presenter.onChangeFilter("String", value, "stats");
    } else if (field === "selectedLeave") {
      this.presenter.onChangeFilter("String", value, "selectedLeave");
    }
    this.setState({ [field]: value });
  }
  getCollectionName() {
    return "leave_request";
  }
  // edit function
  async handleEditData(obj) {
    this.navigateTo(`/form/${this.getCollectionName()}/${obj.id}`);
    // this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  getcurrent() {
    return this.getCurrentUser().employee;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  setWhere(where) {
    this.setState({ where, whereReady: true });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit, where, whereReady } =
      this.state;
    if (!schema) return <Progress />;
    const excludeFieldsFather = [
      "selectedType",
      "halfDay",
      "startdate",
      "enddate",
      "createdAt",
      "duration",
      "stats",
      "employee",
    ];
    const applyField = Object.keys(schema.fields).filter(
      (key) => !excludeFieldsFather.includes(key)
    );
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="">
              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex align-items-center">
                  <div className="d-flex mb-1">
                    {Object.keys(schema.filters || {}).map((field) => {
                      let { type, where: filterWhere, ...options } =
                        schema.filters[field];
                      if (field === "employee") {
                        if (!whereReady) {
                          return (
                            <div key={field} className="ms-1 text-muted fs-sm">
                              Loading employees...
                            </div>
                          );
                        }
                        filterWhere = where || {};
                      }
                      return (
                        <InputFactory
                          key={
                            field === "employee"
                              ? `${field}-${JSON.stringify(filterWhere)}`
                              : field
                          }
                          className="ms-1"
                          type={type}
                          field={field}
                          where={filterWhere}
                          onChange={this.onChangeFilter.bind(this, type)}
                          {...options}
                        />
                      );
                    })}
                    <div className="ms-1">
                      <DateRangePicker
                        fields={["startdate", "enddate", "employee.id"]}
                        onFilter={(filterObj) => {
                          // this.searchSubmit(filterObj);
                          if (Object.keys(filterObj).length > 0) {
                            const updatedAtDate = new Date(
                              filterObj.enddate.$lte
                            );
                            updatedAtDate.setDate(updatedAtDate.getDate() + 1);

                            const updatedFilterObj = {
                              ...filterObj,
                              enddate: {
                                $lte: updatedAtDate.toISOString().split("T")[0],
                              },
                            };
                            this.searchSubmit(updatedFilterObj);
                          } else {
                            this.searchSubmit(filterObj);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </CardView>
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => this.presenter.GeneratePDF()}
                      >
                        <i className="bi bi-filetype-pdf" /> PDF
                      </Button>
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => this.presenter.GenerateExcel()}
                      >
                        <i className="bi bi-filetype-exe" /> Excel
                      </Button>
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => this.presenter.GenerateCSV()}
                      >
                        <i className="bi bi-filetype-csv" /> CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                // empPointer={empPointer}
                objectData={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-pencil-square"> Edit</i>,
                    actionType: "object",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce((acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                }, applyField)}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(LeaveTablePage);
